/**
 * Free vs Premium feature limits + entitlement helpers (frontend mirror).
 *
 * Source of truth lives in `backend/feature_limits.py`. Keep `FREE_LIMITS`
 * values in sync.
 *
 * Subscription state lives on `user.subscription` (the nested view emitted
 * by `serialize_user` on the backend, e.g. via `/api/auth/me`).
 */

export const FREE_LIMITS = Object.freeze({
  plannerDays: 3,
  pantryItems: 20,
  savedRecipes: 10,
});

const PREMIUM_ACCESS_STATUSES = new Set(["active", "trialing", "past_due"]);

const FEATURE_PREMIUM_ACTIVE = "premium.active";


const getSubscription = (user) => user?.subscription || {};


export const isPremium = (user) => {
  if (!user) {
    return false;
  }
  const subscription = getSubscription(user);
  const entitlements = subscription.entitlements || [];
  if (entitlements.includes(FEATURE_PREMIUM_ACTIVE)) {
    return true;
  }
  return subscription.plan_tier === "premium" && PREMIUM_ACCESS_STATUSES.has(subscription.subscription_status);
};


export const canUseFullWeekPlanning = (user) => isPremium(user);


export const freePlannerDayCount = (user) => (isPremium(user) ? 7 : FREE_LIMITS.plannerDays);


export const canAddPantryItem = (user, currentCount) => {
  if (isPremium(user)) {
    return true;
  }
  return currentCount < FREE_LIMITS.pantryItems;
};


export const canSaveRecipe = (user, currentCount) => {
  if (isPremium(user)) {
    return true;
  }
  return currentCount < FREE_LIMITS.savedRecipes;
};
